export default function Footer() {
  return (
    <footer className="bg-teal-600 text-white mt-12">
      <div className="max-w-[1200px] mx-auto px-4 py-8">
        <div className="text-center space-y-4">
          <h2 className="text-xl font-bold">Football Analysis with Professional Data</h2>
          <p className="text-sm leading-relaxed max-w-4xl mx-auto">
            We analyze football matches with in-depth data, providing match predictions with statistics collected from multiple reliable sources. Daily updated match results, comprehensive analysis for every match in every league. Covering Premier League, La Liga, Bundesliga, Ligue 1, Serie A, and other leagues comprehensively. To help visitors consider as a guideline for supporting their favorite teams. Easy-to-read match schedules with all details.
          </p>
          
          <div className="pt-4 border-t border-teal-500">
            <p className="text-xs">
              The website zeankickoff.com does not support gambling. All content and information is only football analysis to show probability and news presentation only. The website has no involvement whatsoever.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 text-sm pt-2">
            <a href="/" className="hover:underline">Football Analysis</a>
            <a href="/" className="hover:underline">Today's Football Analysis</a>
            <a href="/" className="hover:underline">Football Predictions</a>
            <a href="/" className="hover:underline">English Football Analysis</a>
          </div>
          
          <div className="pt-4 text-xs">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:underline">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
